import { Link } from '@mui/material'
import aMd from '../content/a.md?raw'
import bMd from '../content/b.md?raw'
import cMd from '../content/c.md?raw'
import dMd from '../content/d.md?raw'
import tuningMd from '../content/tuning.md?raw'
import escalationMd from '../content/escalation.md?raw'
import { GuideSection, GuideVariant, section } from '../core'
import { ContactNote } from '../components/ContactNote'
import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'

/**
 * 区分は「症状の名前」ではなく「毎日の操作のどこで止まったか」で切る
 * (起動 → 患者選択 → 録音 → SOAP生成)。記号と文言は
 * 紙の店舗シート (Figma) と一致させること。
 *
 * 区分は自己完結させる。目次から各区分・各手順へ直接飛んで読まれるため、
 * 前置きは置かず、他の区分を参照するときは記号 (A-2・B-1) で指す。
 * 手順は安い確認から順に並べ、上から読んで最初に当てはまった場所で止める。
 *
 * 原稿は Notion「Kakeru君 困ったときガイド」(9/14 版の直販向け複製) から起こし、
 * 区分記号と見出しは紙の店舗シートに合わせてある。QuickRec は additional な機能なので
 * 紙にも web にも載せない (区分は A〜D)。hub log/91 決定 24・25。
 */
export const DEFAULT_SECTIONS: GuideSection[] = [
  section({
    id: 'a',
    label: 'A',
    title: 'ログインできない・画面が出ない',
    body: aMd,
  }),
  section({
    id: 'b',
    label: 'B',
    title: '患者一覧に患者が出ない',
    body: bMd,
  }),
  section({
    id: 'c',
    label: 'C',
    title: '録音できない・「マイク接続エラー」が出る',
    body: cMd,
  }),
  section({
    id: 'd',
    label: 'D',
    title: '生成がおかしい（欠けている・言っていない内容がある）',
    body: dMd,
  }),
  section({
    id: 'tuning',
    title: '生成を好みに近づけるには',
    body: tuningMd,
  }),
  section({
    id: 'escalation',
    title: 'それでも解決しないとき',
    body: escalationMd,
  }),
]

const SUPPORT_EMAIL = 'support@medilab.co.jp'

/**
 * default = 直販 (support@ が一次窓口)。/guide が持つ。
 * mailto はアドレスのインラインリンクに留める (店頭 PC はメーラ未設定が普通で、
 * リンクならメーラがある環境でだけ開き、無くても文章として成立する)。
 */
export const defaultVariant: GuideVariant = {
  sections: DEFAULT_SECTIONS,
  contact: (
    <ContactNote>
      <Link
        href={`mailto:${SUPPORT_EMAIL}`}
        underline="none"
        sx={{ color: colorTokens.accent.primary }}
      >
        {SUPPORT_EMAIL}
      </Link>{' '}
      までお知らせください。月〜金 9:00〜18:00 に、原則当日中、遅くとも 1
      営業日以内をめどに、受け取りのご連絡と回答の目安をお返しします。
    </ContactNote>
  ),
}
